<template>
  <v-menu
    style="max-height:250px;"
    open-delay="900"
    open-on-click
    top
    left
    content-class="dropdown-menu"
    offset-y
    transition="slide-y-transition">
    <template v-slot:activator="{ on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        icon
        flat
        dark
        small
        v-on="on"
      >
        <v-badge
          color="red"
          overlap
          bordered
        >
          <template
            v-slot:badge
            v-if="notificacoes !== null && notificacoes['count'] > 0">
            <span>{{ notificacoes['count'] > 99 ? '+99' : notificacoes['count'] }}</span>
          </template>

          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <notificacoes-data :notificacoes="notificacoes"/>
  </v-menu>
</template>
<script>
// Utilities
import {
  mapActions,
  mapState
} from 'vuex'
import NotificacoesData from './NotificacoesData.vue'

export default {
  components: { NotificacoesData },
  data: () => ({
    notificacoes_: [],
    logo: './img/header-logo.png',
    intNot: null,
    count: null,
    tries: 0
  }),
  computed: {
    ...mapState('app', ['notificacoes'])
  },
  created () {
    this.getNotificacoes()
    this.intNot = setInterval(() => {
      try {
        this.getNotificacoes()
        this.tries = 0
      } catch (error) {
        this.tries++
        if (this.tries > 3) {
          clearInterval(this.intNot)
        }
      }
    }, 60000 * 5)
  },
  beforeDestroy () {
    if (this.intNot !== null) {
      clearInterval(this.intNot)
    }
  },
  methods: {
    ...mapActions(['getNotificacoes']),
    getNotificacoes_ () {
      this.axios.post('notificacoes').then(res => {
        this.notificacoes = res.data.data
        if (!("Notification" in window)) return
        if (Notification.permission === 'granted' && this.count !== null && (parseInt(_.get(this.notificacoes, 'count')) - parseInt(this.count)) > 0) {
          var myNotification = new Notification('Uma nova notificação', { body: 'Novas notificações estão disponíveis no BR-Corte!!!', icon: 'https://brcorte.com.br/favicon.png' })
          myNotification.addEventListener('click', () => {
            window.location.href = '/'
          })
        }
        this.count = _.get(this.notificacoes, 'count')
      })
    }
  }

}
</script>
